export const routes = {
    checkout: '/checkout',
    cart: '/cart',
    search: '/search',
    searchResult: '/search-result',
    businesses: '/businesses',
    orderConfirm: '/order',
    redemption: '/redemption',
    switchMerchant: '/switch-merchant',
    merchantInquiry: '/merchant-inquiry',
    accountLogin: '/account/login',
    account: '/account',
    profile: '/account/profile',
    temporarily_unavailable: '/temporarily-unavailable',
    store_closed: '/store-closed',
    home: '/',
} as const;
